import { EndpointKey } from '../http/EndpointKey';
import { updateVerificationExpired } from '../store/app/action-creators';
import { retryEndpoint } from '../store/http-responses/action-creators';
import { Tracker } from '../store/tracking/action-creators';
export const handleCodeVerificationRefreshSuccess = (response, dispatch) => {
  dispatch(Tracker.signupInteraction('signup-error-verification-refreshed'));
  dispatch(retryEndpoint(EndpointKey.Signup));
  dispatch(updateVerificationExpired(false));
};